var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5306 3.11849C0 5.64909 0 9.72203 0 17.8679V19.3079C0 27.4538 0 31.5267 2.5306 34.0573C5.0612 36.5879 9.13414 36.5879 17.28 36.5879H18.72C26.8659 36.5879 30.9388 36.5879 33.4694 34.0573C36 31.5267 36 27.4538 36 19.3079V17.8679C36 9.72203 36 5.64909 33.4694 3.11849C30.9388 0.587891 26.8659 0.587891 18.72 0.587891H17.28C9.13414 0.587891 5.0612 0.587891 2.5306 3.11849ZM6.07507 11.538C6.27005 20.898 10.95 26.5229 19.155 26.5229H19.6201V21.1679C22.6351 21.4679 24.915 23.673 25.8299 26.5229H30.0901C28.9201 22.263 25.8449 19.9079 23.9249 19.0079C25.8449 17.898 28.5449 15.198 29.1899 11.538H25.3198C24.4798 14.508 21.9901 17.2079 19.6201 17.4629V11.538H15.75V21.9179C13.35 21.318 10.32 18.408 10.185 11.538H6.07507Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkIcon);
export default __webpack_public_path__ + "static/media/VKIcon.efdfc3e024a67bdd5e57b50a6f020d5a.svg";
export { ForwardRef as ReactComponent };